import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './local-storage.service';
import { OtpRequestResponse, OtpVerificationResponse } from '../interfaces/responses/models';
import { OtpRequest, OtpVerificationRequest } from '../interfaces/requests/models';

import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient, 
    private localStorageService: LocalStorageService,
    private userService: UserService
  ) { }

  private createUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  requestOtpForUser(phone_number: number): Observable<OtpRequestResponse> {
    const otpRequest: OtpRequest = { 
      phone_number: phone_number.toString(), 
      country_code: '+91' 
    };
    return this.http.post<OtpRequestResponse>(this.createUrl('auth/user'), otpRequest);
  }

  verifyOtp(state_token: string, otp: string, role?: string): Observable<OtpVerificationResponse> {
    const otpVerification: OtpVerificationRequest = { otp, state_token, ...(role ? { role } : {}) };
    return this.http.post<OtpVerificationResponse>(this.createUrl(`auth/${state_token}`), otpVerification);
  }

  isUserLoggedIn(): boolean {
    return this.localStorageService.getUser() !== "";
  }

  setUser(user: string): void {
    this.localStorageService.setUser(user);
  }

  async setToken(token: string): Promise<void> {
    await this.localStorageService.setToken(token);
  }

  setRole(role: any): void {
    this.localStorageService.setRole(role);
  }

  getRole(): string {
    return this.localStorageService.getRole();
  }

  getUserId(): string {
    return this.localStorageService.getUserId();
  }

  setUserId(userId: string): void {
    this.localStorageService.setUserId(userId);
  }

  async logout(): Promise<void> {
    await this.localStorageService.clear();
  }

  getBasicCurrentUserDetails(): Observable<any> {
    return this.userService.getCurrentUserDetails();
  }

  getUserUtilityConfiguration(): Observable<any> {
    return this.userService.getUserUtilityConfiguration();
  }
}
